import React from 'react';
import { motion } from 'framer-motion';
import doctorImage from '../images/logo_.png';

const DoctorProfile = () => {
  return (
    <section className="doctor-profile">
      <div className="container">
        <motion.div
          className="profile-card"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="profile-image profile-image-real">
            <img src={doctorImage} alt="Dr. Santosh Kumar" />
          </div>
          <div className="profile-info">
            <span className="section-kicker">Lead Physician</span>
            <h2>Dr. Santosh Kumar</h2>
            <p className="qualification">MD, Gold Medalist</p>
            <div className="profile-description">
              <p>
                Dr. Santosh Kumar brings more than two decades of experience in guiding patients dealing
                with diabetes, insulin dependency, and kidney-related complications. His care style combines
                medical discipline, patient education, and compassionate follow-up.
              </p>
              <p className="profile-hindi">
                मरीजों और उनके परिवारों को आसान हिंदी में समझाना, सही दिनचर्या बताना और लंबे समय तक
                निगरानी रखना उनकी देखभाल की सबसे खास पहचान है।
              </p>
            </div>
            <div className="awards">
              <h3>Awards & Recognitions</h3>
              <ul>
                <li>MD Gold Medalist</li>
                <li>20+ Years of Clinical Practice</li>
                <li>Patient-focused Diabetes Guidance</li>
                <li>Structured Follow-up Care</li>
              </ul>
            </div>
            <div className="specialization">
              <h3>Specialization</h3>
              <ul>
                <li>Diabetes Management</li>
                <li>Insulin Support Guidance</li>
                <li>Kidney Wellness Monitoring</li>
                <li>Lifestyle & Diet Counseling</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DoctorProfile;
